<template>
  <div class="recover-password">
    <h2>{{'auth.recoverPassword' | translate}}</h2>
    <div v-show="error" class="error">
      {{ error }} {{ 'auth.try_again' | translate }}
    </div>
    <form v-show="!success" v-on:submit.prevent="recover">
      <div class="form-group">
        <div class="input-group">
          <input :placeholder="$t('auth.email')" type="text" id="email" required="required" v-model="email"/>
          <small v-show="invalidEmail" class="help text-danger">
            {{'auth.invalidEmail' | translate}}
          </small>
          <small v-if="!invalidEmail"> {{ 'auth.email_notification' | translate }}</small>
        </div>
      </div>
      <div class="d-flex flex-column flex-lg-row align-items-center justify-content-between mt-5">
        <button class="btn btn-primary btn-block" type="submit" :disabled="isLoading || invalidEmail" >
          {{ 'auth.send' | translate}}
        </button>
      </div>
    </form>
    <div v-if="success" class="d-flex flex-column flex-lg-col align-items-center justify-content-center mt-5 mb-5">
      <b>{{ success }}</b>
      <span class="text-center" v-text="$t('auth.email_send_notification')"/>
      <va-button class="w-100 mt-5" :to="{name: 'login'}">
        {{$t('auth.login')}}
      </va-button>
    </div>
    <div class="d-flex justify-content-center mt-2">
      <router-link :to="{name: 'login'}">{{$t('auth.go_back')}}</router-link>
    </div>
    <div class="loading" v-show="isLoading">
      <hollow-dots-spinner
        :animation-duration="2500"
        :size="60"
        color="#29c4a9"
      />
    </div>
  </div>
</template>

<script>
import { HollowDotsSpinner } from 'epic-spinners'
import { EMAIL_REGEX } from '@/utils/regex'
import Vue from 'vue'
export default {
  name: 'recover',
  components: {
    HollowDotsSpinner
  },
  data () {
    return {
      email: null,
      error: null,
      isLoading: false,
      success: null
    }
  },
  methods: {
    recover () {
      this.$http({
        url: this.$store.state.evollauth_server + '/auth/recoverpassword',
        data: { email: this.email.toLowerCase() },
        method: 'POST'
      }).then((response) => {
        console.log(response);
        this.success = this.$t('auth.email_send')
        this.email = null
      }).catch((error) => {
        console.log(error)
        if (error.response.status === 404) {
          this.error = this.$t('auth.valid_email_but_without_a_registered_account')
        }else if (error.response.status === 400 || error.response.status === 422) {
          this.error = this.$t('auth.invalidEmail')
        }else if (error.response.status === 403) {
          console.log("HERE")
          this.error = this.$t('auth.account_is_blocked')
        }else{
          this.error = error.response.data.errors[0].msg
        }

      })
    },
  },
  computed: {
    invalidEmail: function () {
      if (this.email) {
        return !this.email.match(EMAIL_REGEX)
      }
      return false
    }
  },
  mounted () {
    var userLang = window.navigator.language || window.navigator.userLanguage
    userLang = userLang.toLowerCase().slice(0, 2)
    switch (userLang) {
      case 'pt':
        Vue.i18n.set('pt')
        break
      case 'es':
        Vue.i18n.set('es')
        break
      case 'en':
      default:
        Vue.i18n.set('en')
        break
    }
  },
  watch: {
    email: function (value) {
      if (value && value.length > 0 && (this.error !== null || this.success !== null)) {
        this.error = null
        this.success = null
      }
    }
  }
}
</script>

<style lang="scss">
  .recover-password {
    @include media-breakpoint-down(md) {
      width: 100%;
      padding-right: 1rem;
      padding-left: 1rem;
    }

    h2 {
      text-align: center;
      margin-bottom: 1rem;
    }

    input {
      width: 100%;
      height: 2.5rem;
      padding-left: 20px;
      margin-top: 1.5rem;
      margin-bottom: 1.5rem;
      background-color: #E8E8E8;
      color: #414141;
      border: none;
      &::placeholder {
        color: #6E6E6E;
      }
      &:focus {
        outline: 0;
      }
    }

    .error {
      text-align: center;
      margin-bottom: 1rem;
      color:red;
      word-wrap:break-word;
    }
  }

  .loading {
    margin-top: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 40%;
    left: 50%;
  }

</style>
